import type { components } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';

export type TeamListResponse = components['schemas']['TeamListResponse'];
export type Team = TeamListResponse['data'][number];

export const fetchTeams = async (): Promise<Team[]> => {
  const { data, error } = await ffhClient().GET('/league/teams', {});
  if (error) throw new Error('Failed to load teams');
  return data?.data ?? [];
};
